export default {
  title: 'Managment Chapters',
  btnAddChapters:'Add Chapter',
  btnEditChapter:'Edit Chapter',
  btnEditMedia:'Edit media',
  btnAddMedia:'Add media',
  labelTitle:'title',


  typeClip:'clip',
  typeAudio:'audio',
  typeGame:'game',
  labelLink:'link|url',

  edit:'Edit',
  editMedia:'Edit media',
  labelNameFa:'name fa',
  labelNameEn:'name en',
  labelType:'type',
  back:'back',
  save:'save',
  saving:'saving ...',


  placeholderNameEn:'Enter name en',
  placeholderNameFa:'Enter name fa',
  placeholderTitle:'Enter title',
  placeholderType:'select type',
  placeholderLink:'Enter link',

  
  deleteConfirm:'Are you sure you want to delete?',

  loading:'loading ...',
  empty:'list is empty',



}
